import { Flex, Loader, Overlay } from "@mantine/core";

export const LoadingOverlay = ({ isLoading }: { isLoading: boolean }) => (
    isLoading ? (
        <Overlay opacity={0.6} color="#000" zIndex={1000}>
            <Flex w="100%" h="100%" justify="center" align="center">
                <Loader size="xl" />
            </Flex>
        </Overlay>
    ) : null
);